import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonWrapperComponent } from './button-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    ButtonWrapperComponent
  ],
  exports: [
    ButtonWrapperComponent
  ]
})
export class ButtonWrapperModule { }
